import { render, staticRenderFns } from "./conta_verif.vue?vue&type=template&id=42718588"
import script from "./conta_verif.vue?vue&type=script&lang=js"
export * from "./conta_verif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports